import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import type { ActiveLocationGroup } from "..";
import { allLocationRuns } from "../LocationRun/catalog";
import type { PartLabelOffset } from "../LocationPartLabels/labels";

/** Skip nested chips when that part already has its own stack under the primary. */
export function partLabelsWithoutOwnStacks(
  groups: readonly ActiveLocationGroup[],
  layout: BookTimelineLayout,
  offsets: readonly PartLabelOffset[],
): PartLabelOffset[] {
  const runs = allLocationRuns(layout);
  const ownStack = new Set<string>();
  for (const group of groups) {
    for (const member of group.members) {
      if (!member.visible || member.role !== "secondary") {
        continue;
      }
      if (member.phase !== "active") {
        continue;
      }
      const run = runs.find((item) => item.runId === member.runId);
      if (run !== undefined) {
        ownStack.add(run.locationLabel);
      }
    }
  }
  if (ownStack.size === 0) {
    return [...offsets];
  }
  return offsets.filter((part) => !ownStack.has(part.label));
}
